export class Signature {
  id?: number;
  fileName?: string;
  fileType?: string;
  modified?: string;
  url?: string;
}
